import { getApiBaseUrl } from './apiBaseUrl';

const createHttpError = (message, status) => {
  const error = new Error(message);
  error.status = status;
  return error;
};

export const loginAdmin = async (loginId, password) => {
  const response = await fetch(`${getApiBaseUrl()}/api/admin/auth/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      loginId,
      password,
    }),
  });

  if (!response.ok) {
    throw createHttpError(`Failed to login: ${response.status}`, response.status);
  }

  return response.json();
};

export const fetchAdminSession = async () => {
  const response = await fetch(`${getApiBaseUrl()}/api/admin/auth/me`, {
    credentials: 'include',
  });

  if (response.status === 401) {
    return null;
  }

  if (!response.ok) {
    throw createHttpError(`Failed to fetch admin session: ${response.status}`, response.status);
  }

  return response.json();
};

export const logoutAdmin = async () => {
  const response = await fetch(`${getApiBaseUrl()}/api/admin/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    throw createHttpError(`Failed to logout: ${response.status}`, response.status);
  }
};

